<template>
  <div class="panel">
    <div class="panel-header">
      <h3 class="panel-header-title">
        {{ graphic.chartOptions.title.label }}
      </h3>
    </div>
    <div class="panel-body">
      <apexchart
        type="bar"
        height="250"
        :options="graphic.chartOptions"
        :series="graphic.series"
      ></apexchart>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue3-apexcharts";

export default {
  name: "QrGraphic",
  components: { apexchart: VueApexCharts },
  props: {
    rep_graphic: {
      type: Object,
      required: true
    }
  },
  computed: {
    graphic: function() {
      return this.barGraphics(this.rep_graphic);
    }
  },
  methods: {
    barGraphics: function (graph) {
      return {
        series: [
          { name: graph.title, data: graph.data.map(item => item.value) }
        ],
        chartOptions: {
          chart: {
            type: "bar",
            height: 350
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: "55%",
              endingShape: "rounded"
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 2,
            colors: ["transparent"]
          },
          xaxis: {
            labels: {
              rotate: -45,
              style: {
                fontSize: "11px"
              }
            },
            categories: graph.data.map(item => item.label)
          },
          yaxis: {
            labels: {
              formatter: function (val) {
                return parseInt(val * 100) / 100;
              }
            }
          },
          title: { label: graph.title },
          fill: {
            opacity: 1,
            colors: [graph.color ?? "#95b3d7"]
          }
        }
      };
    }
  },
};
</script>
